export const mutationTypes = {
  SET_THEME: 'SET_THEME',
  SET_USER_ID: 'SET_USER_ID',
  SET_LANGUAGE: 'SET_LANGUAGE',
  SET_LOCALE: 'SET_LOCALE',
  SET_CONTINUATION_ROUTE: 'SET_CONTINUATION_ROUTE',
  GENERAL_ERROR: 'GENERAL_ERROR',
  LOGIN_FAILURE: 'LOGIN_FAILURE',
  LOGIN_PENDING: 'LOGIN_PENDING',
  LOGIN_REDIRECT: 'LOGIN_REDIRECT',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGOUT_FAILURE: 'LOGOUT_FAILURE',
  LOGOUT_PENDING: 'LOGOUT_PENDING',
  LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
  GET_REPORT_LIST_SUCCESS: 'GET_REPORT_LIST_SUCCESS',
  GET_REPORT_LIST_PENDING: 'GET_REPORT_LIST_PENDING',
  GET_REPORT_LIST_FAILURE: 'GET_REPORT_LIST_FAILURE',
  RETRIEVE_CURRENT_USER_PENDING: 'RETRIEVE_CURRENT_USER_PENDING',
  RETRIEVE_CURRENT_USER_SUCCESS: 'RETRIEVE_CURRENT_USER_SUCCESS',
  RETRIEVE_CURRENT_USER_FAILURE: 'RETRIEVE_CURRENT_USER_FAILURE',
  RESET_STATE: 'RESET_STATE'
}

export default {
  mutationTypes
}
